import { Capacitor } from "@capacitor/core";
import { StatusBar } from "@capacitor/status-bar";
import { NavigationBar } from "@hugotomazi/capacitor-navigation-bar";
import { useEffect } from "react";
import DataController from "@controllers/DataController";

export const useAppLaunchSetup = () => {
  useEffect(() => {
    const setNavbarColors = async (): Promise<void> => {
      if (!(await DataController.isWebAsync()) && Capacitor.getPlatform() === "android") {
        try {
          StatusBar.setOverlaysWebView({ overlay: true });
          StatusBar.setBackgroundColor({ color: "#000" });
          NavigationBar.setColor({ color: "#026F8A" });
        } catch (error) {
          console.log(error);
        }
      }
    };

    setNavbarColors();
  }, []);
};
